module.exports = __webpack_public_path__ + "img/icon-work-2.d3ffec9f.svg";